/**
 * Wire up interactions in the header.
 */
(function($) {
  $(".ccc-menu-container").hover(
    function() {
      $(".ccc-menu-dropdown-list")
        .stop(true, true)
        .slideToggle(400);
    },
    function() {
      $(".ccc-menu-dropdown-list")
        .stop(true, true)
        .slideUp(0);
    }
  );
})(jQuery);
